module.exports = __webpack_public_path__ + "images/f541813061d602f0ad5e979c1612e348.png";